import React, { useState } from 'react';
import TableManager from '../../components/TableManager';
import useIcons from '../../assets/icons/useIcons';
import Button from '../../components/Button';
import AsideModal from '../../components/AsideModal';
import AddCarrier from './AddCarrier';
import { getCarrier } from '../../api';
import useUserActivation from '../../hooks/useUserActivation';
import useUserDeactivation from '../../hooks/useUserDeactivation';
import Dropdown from '../../components/Dropdown';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../helpers/functions';
import useDashBoardLogin from '../../hooks/useDashBoardLogin';

const filterInitialValues = {
  filter: [
    {
      key: 'firstName',
      value: '',
      isChecked: false,
      inputPlaceholder: 'Enter Name',
      inputType: 'text',
      inputLabel: 'Name',
    },

    {
      key: 'email',
      value: '',
      isChecked: false,
      inputPlaceholder: 'Enter Email',
      inputType: 'email',
      inputLabel: 'Email',
    },
    {
      key: 'phone',
      value: '',
      isChecked: false,
      inputPlaceholder: 'Enter Phone#',
      inputType: 'phone-number',
      inputLabel: 'Phone',
    },
  ],
};

const initialEditInstance = { isEdit: false, editData: {} };
export default function Carrier() {
  const [addCarrier, setaddCarrier] = useState(false);
  const { mutate: activateUser } = useUserActivation();
  const { mutate: deactivateUser } = useUserDeactivation();
  const { mutate: mutateDashBoardLogin } = useDashBoardLogin();

  const [editCarrierInstance, seteditCarrierInstance] =
    useState(initialEditInstance);
  const { MoreVIcon } = useIcons();
  const navigate = useNavigate();
  const handleChangeStaus = (data) => {
    if (data?.is_active) {
      deactivateUser({ uuid: data?.uuid });
    } else {
      activateUser({ uuid: data?.uuid });
    }
  };

  const handleDropListClick = async ({ value }, data) => {
    const { _id } = data || {};

    switch (value) {
      case 'edit':
        seteditCarrierInstance({ isEdit: true, editData: data });
        setaddCarrier(true);
        break;
      case 'change-status':
        handleChangeStaus(data);
        break;
      case 'view':
        navigate(`/user-info/${_id}/profile`);
        break;
      case 'go_to_dashboard':
        mutateDashBoardLogin(_id);
        break;

      default:
        break;
    }
  };

  const handleUserDetailsModal = (data) => {
    // navigate(`/user-info/${data?.uuid}/dashboard`);
    navigate(`/user-info/${data?.uuid}/profile`);
  };

  const columns = [
    {
      accessorKey: 'full_name',
      accessorFn: (row) => `${row.firstName} ${row.lastName}`,
      header: () => 'Full Name',
      cell: (props) => {
        const element = props.row.original;
        return (
          <span
            className="c--pointer text--danger font--600 d--flex gap--sm d--flex align-items--center justify-content--start"
            // onClick={() => handleUserDetailsModal(props?.row?.original)}
          >
            {element?.status === 'ACTIVATE' ? (
              <div
                data-tooltip={'Active'}
                tooltip-position="top"
                className="bg--success radius--full p-l--sm  p-r--sm w-min--20 h-min--20 w-max--20 h-max--20  text--white d--flex justify-content--center align-items--center"
              >
                A
              </div>
            ) : (
              <div
                data-tooltip={'Deactive'}
                tooltip-position="top"
                className="bg--secondary radius--full p-l--sm p-r--sm w-min--20 h-min--20 w-max--20 h-max--20 text--white d--flex justify-content--center align-items--center"
              >
                D
              </div>
            )}
            {props.getValue()}
          </span>
        );
      },
      meta: {
        textAlign: 'left',
      },
    },
    {
      accessorKey: 'email',
      header: () => 'Email',
      meta: {
        textAlign: 'left',
      },
    },
    {
      accessorKey: 'phone',
      header: () => 'Phone',
      meta: {
        textAlign: 'left',
      },
    },
    {
      accessorKey: 'createdAt',
      header: () => 'Registration On',
      cell: (props) => formatDate(props.getValue()),
      meta: {
        textAlign: 'left',
      },
    },
    {
      accessorKey: 'action',
      header: () => 'Action',
      cell: (props) => {
        const element = props?.row?.original;
        return (
          <div className="gap--xs w--full d--flex align-items--center justify-content--center">
            <Dropdown
              closeOnClickOutside={true}
              dropList={{
                component: ({ item }) => (
                  <span
                    className="w--full d--flex  justify-content--start p--sm"
                    onClick={() => handleDropListClick(item, element)}
                  >
                    {item?.title}
                  </span>
                ),
                data: [
                  // { title: 'View', value: 'view' },
                  // { title: 'Edit', value: 'edit' },
                  // {
                  //   title: `${element?.is_active ? 'Deactivate' : 'Activate'}`,
                  //   value: 'change-status',
                  // },
                  { title: 'Go to dashboard', value: 'go_to_dashboard' },
                ],
              }}
              showcaret={false}
            >
              <div className="w-min--32 h-min--32 d--flex align-items--center justify-content--center radius--sm bg--black-100 text--black  c--pointer">
                <MoreVIcon width={15} height={15} />
              </div>
            </Dropdown>
          </div>
        );
      },
      meta: {
        colType: 'action',
        textAlign: 'center',
        width: '8%',
      },
    },
  ];

  const tableActions = [
    {
      id: 1,
      access: true,
      component: (
        <Button
          type="button"
          btnClasses="btn w-min--150"
          variant="primary"
          color="black"
          onClick={() => setaddCarrier(true)}
        >
          Add Carrier
        </Button>
      ),
    },
  ];
  const handleClose = () => {
    seteditCarrierInstance({ isEdit: false, editData: {} });
    setaddCarrier(false);
  };

  return (
    <div className="w--full">
      <TableManager
        {...{
          fetcherKey: 'getCarrier',
          fetcherFn: getCarrier,
          columns,
          name: 'Carrier',
          shouldFilter: true,
          initialFilterState: filterInitialValues,
          selectCBForTableData: (tblData) => tblData?.data?.data?.users,
        }}
      />
      {addCarrier && (
        <AsideModal
          handleClose={handleClose}
          title="Carrier"
          footerComponent={null}
        >
          <AddCarrier
            editCarrierInstance={editCarrierInstance}
            handleClose={handleClose}
          />
        </AsideModal>
      )}
    </div>
  );
}
